import React, { ChangeEvent } from "react";
import { RadioButtonWithLabel } from "../../../components";
import { Text, TextField } from "@telia/teddy";
import { RejectReason, RejectReasonID } from "../../../../../models/transfer";
import TEXT from "../../text-consts";

interface RejectContentProps {
    handleReasonChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleRejectReasons: (id: RejectReasonID) => void;
    reasons: RejectReason[];
    rejectReason: string;
    rejectReasons: RejectReasonID | null;
}

const RejectContent: React.FC<RejectContentProps> = ({
    reasons,
    rejectReason,
    rejectReasons,
    handleRejectReasons,
    handleReasonChange,
}) => (
    <div className="consent-landing-page__consent-expanded">
        <Text mb="100" variant="additional-100">
            {TEXT.CONSENT_FORMER_LEGAL.REJECT_DESCRIPTION}
        </Text>
        <div className="consent-landing-page__consent-reject-container">
            {reasons.map((reason) => (
                <div key={reason.id} className="consent-landing-page__consent-reject-option">
                    <RadioButtonWithLabel
                        checked={rejectReasons === reason.id}
                        label={reason.text}
                        onChange={() => handleRejectReasons(reason.id)}
                    />
                    {rejectReasons === "OTHER" && rejectReasons === reason.id && (
                        <TextField className="reject-reason">
                            <TextField.Input
                                placeholder="Beskriv kort årsaken"
                                value={rejectReason}
                                onChange={handleReasonChange}
                            />
                        </TextField>
                    )}
                </div>
            ))}
        </div>
    </div>
);

export default RejectContent;
